"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alertOverrides = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("@mui/material/SvgIcon"));
var _dist = require("@aaa-ncnu-ie/icons/dist");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var alertOverrides = {
  MuiAlertTitle: {
    styleOverrides: {
      root: function root(_ref) {
        var _ref$theme = _ref.theme,
          palette = _ref$theme.palette,
          spacing = _ref$theme.spacing,
          typography = _ref$theme.typography;
        return {
          // .MuiAlert-root
          color: palette.common.black,
          fontWeight: typography.fontWeightBold,
          marginBottom: spacing(0.5)
        };
      }
    }
  },
  MuiAlert: {
    defaultProps: {
      components: {
        // TODO: "components" is deprecating since 5.10.13. Replace with "slots"
        CloseIcon: function CloseIcon(props) {
          return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, _extends({
            component: _dist.DefaultRemove
          }, props));
        }
      },
      closeText: 'Close',
      iconMapping: {
        error: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
          component: _dist.FillWarningTriangle
        }),
        info: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
          component: _dist.FillInfo
        }),
        success: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
          component: _dist.FillCheckmark
        }),
        warning: /*#__PURE__*/_react.default.createElement(_SvgIcon.default, {
          component: _dist.FillWarning
        })
      },
      variant: 'outlined'
    },
    styleOverrides: {
      root: function root(_ref2) {
        var _ref2$ownerState = _ref2.ownerState,
          color = _ref2$ownerState.color,
          _ref2$ownerState$seve = _ref2$ownerState.severity,
          severity = _ref2$ownerState$seve === void 0 ? 'success' : _ref2$ownerState$seve,
          _ref2$theme = _ref2.theme,
          palette = _ref2$theme.palette,
          borders = _ref2$theme.borders,
          spacing = _ref2$theme.spacing;
        return {
          // .MuiAlert-root
          padding: "".concat(spacing(0.75), " ").concat(spacing(3)),
          color: palette.grey[600],
          // TODO: Check if this color is being applied anywhere
          '&.MuiAlert-outlined': {
            backgroundColor: palette[color || severity].lighter,
            borderWidth: borders.medium,
            borderColor: palette[color || severity].dark
          },
          '.MuiAlert-icon': {
            color: palette[color || severity].dark
          },
          '.MuiAlert-message': {
            color: palette.grey[600]
          },
          '.MuiAlert-action': {
            color: palette.common.black
          }
        };
      }
    }
  }
};
exports.alertOverrides = alertOverrides;